import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetUserCacheApi, GetUserCacheByRoleApi } from '@/apis/systems/users.api';
import { List, indexOf } from 'lodash';

const { wsCache } = useCache();
const CacheKey = 'UserCacheList';

export const useUser = defineStore('user_maps', {
	state: (): any => ({
		useList: [] as any[],
	}),
	actions: {
		getName(account: string) {
			const user = this.useList.filter((user: any) => user.account == account)[0] ?? '';
			return user.user_name ?? '--';
		},
		getSelectList(key: string, needAll?: false) {
			const selectList = [];
			if (needAll) selectList.push({ value: '', label: '全部' });

			this.useList
				.filter((user: any) => user.status == 1 && user.is_lock == 'N')
				.forEach((user: any) => {
					selectList.push({ value: user.account, label: `${user.user_name}(${user.account})` });
				});

			return selectList;
		},

		getSelectListWithoutFinance(key: string, needAll?: false) {
			const selectList = [];
			if (needAll) selectList.push({ value: '', label: '全部' });

			this.useList
				.filter((user: any) => user.status == 1 && user.is_lock == 'N' && indexOf(this.financeList,user.id) < 0)
				.forEach((user: any) => {
					selectList.push({ value: user.account, label: `${user.user_name}(${user.account})` });
				});

			return selectList;
		},

		async setUserMap() {
			this.useList = [];
			wsCache.delete(CacheKey);

			let dataList = wsCache.get(CacheKey);
			if (!dataList) {
				dataList = await this.getDataList();
			}
			GetUserCacheByRoleApi("财务").then((res: any) => {
				this.financeList = res.data ?? [];
			}
			)

			this.useList = dataList;
		},
		getDataList() {
			return new Promise((resolve) => {
				GetUserCacheApi().then((res: any) => {
					const dicList = res.data ?? [];
					wsCache.set(CacheKey, dicList);
					resolve(dicList);
				});
			});
		},
	},
});
